import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/ResetPassword.css";
import loginImage from "../assets/login.jpg";
import { API_BASE_URL } from "../config/api";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, newPassword }),
      });

      const data = await response.json();

      if (response.ok) {
        navigate("/password/success");
      } else {
        setError(data.message || "Erreur lors de la réinitialisation.");
      }
    } catch (err) {
      setError("Erreur réseau.");
      console.error(err);
    }
  };

  return (
    <div className="reset-wrapper">
      <div className="reset-left">
        <img
          src="{loginImage}"
          alt="Admin"
        />
        <div className="reset-text">
          <h2>Espace Administrateur</h2>
          <p>
            Gérez vos prestations, vos locations et vos utilisateurs depuis votre espace
            administrateur.
          </p>
        </div>
      </div>

      <div className="reset-right">
        <h1 className="logo">
          <span className="blue">Waa</span><span className="black">Go</span>
        </h1>
        <h2>Mot de passe oublié</h2>
        <p>
          Choisissez un nouveau mot de passe et confirmez-le pour sécuriser votre compte.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Mot de passe"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Confirmez mot de passe"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <button type="submit" className="submit-btn">Réinitialiser</button>
        </form>

        {error && <p className="error-message">{error}</p>}

        <a href="/login" className="back-link">Se connecter</a>
      </div>
    </div>
  );
};

export default ResetPassword;
